// removed by extract-text-webpack-plugin
module.exports = {"Assist":"Assist__Assist__i4Lwv","Button":"Assist__Button__trSiv","Title":"Assist__Title__2zguZ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Assist/Assist.css
// module id = 140
// module chunks = 0